import type { SVGProps } from 'react'
const SvgSyBasket = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M19.78 10H20a1 1 0 1 0 0-2H4a1 1 0 0 0 0 2h.22a1 1 0 0 1 .97.758l1.431 5.727A2 2 0 0 0 8.561 18h6.877a2 2 0 0 0 1.94-1.515l1.433-5.727a1 1 0 0 1 .97-.758"
		/>
		<path d="M8.402 3.01a.5.5 0 0 0-.318.213l-2 3a.5.5 0 0 0 .139.693.5.5 0 0 0 .693-.139l2-3a.5.5 0 0 0-.139-.693.5.5 0 0 0-.375-.074m7.196 0a.5.5 0 0 0-.375.074.5.5 0 0 0-.139.693l2 3a.5.5 0 0 0 .693.139.5.5 0 0 0 .139-.693l-2-3a.5.5 0 0 0-.318-.213m-6.256 8.015a.5.5 0 0 0-.317.633l1 3a.5.5 0 0 0 .633.317.5.5 0 0 0 .317-.633l-1-3a.5.5 0 0 0-.633-.317m5.316 0a.5.5 0 0 0-.633.317l-1 3a.5.5 0 0 0 .317.633.5.5 0 0 0 .633-.317l1-3a.5.5 0 0 0-.317-.633" />
	</svg>
)
export default SvgSyBasket
